
const SessionStorageKeys = {
    token : 'token',
    type: 'type',
    companyName: 'companyName',
    name: 'name',
    companyId: 'companyId'
};

export default SessionStorageKeys;